// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ski-byod-device-register.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ski-byod-device-register',
  title: 'Maintain a register of all BYOD devices used for service delivery',
  description:
    'All personally-owned devices used to deliver government framework services must be recorded in a register that includes the device manufacturer, model, operating system version and security features. The register must be kept current and reviewed regularly.',
  category: 'assets',
  scfIds: ['SCF-AST-001', 'SCF-AST-006'],
  cadence: { frequency: '6m', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'BYOD device register procedure is documented' },
    { type: 'document-within-sla', description: 'Register is current and review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
